import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let queuedAt = 0;
const QUEUED = "Queued, will send shortly. The email service is busy right now, so it will go out automatically in a few minutes.";
const showQueued = (opts?: any, msg?: any) => {
  queuedAt = 0;
  const description = typeof msg === "string" ? msg.replace(/\b(sent|emailed)\b/gi, "queued") : opts?.description;
  return toast.info(QUEUED, { ...opts, description, id: "email-queued", duration: 9000 });
};
const origSuccess = toast.success;
(toast as any).success = (msg: any, opts?: any) => (queuedAt && Date.now() - queuedAt < 4000 ? showQueued(opts, msg) : origSuccess(msg, opts));

let refreshing: Promise<unknown> | null = null;

api.interceptors.response.use(
  (r) => {
    if (r.headers?.["x-email-queued"]) {
      queuedAt = Date.now();
      setTimeout(() => { if (queuedAt) showQueued(); }, 600);
    }
    return r;
  },
  async (error) => {
    const orig = error.config || {};
    const url: string = orig.url || "";
    if (error.response?.status === 401 && !orig._retry && (url.startsWith("/admin") || url.startsWith("/dow"))) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch {
        refreshing = null;
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

const VIEWABLE = /\.(pdf|png|jpe?g|gif|webp)$/i;

export async function downloadFile(url: string, filename: string) {
  const tab = VIEWABLE.test(filename) ? window.open("", "_blank") : null;
  let r;
  try { r = await api.get(url, { responseType: "blob" }); } catch (e) { tab?.close(); throw e; }
  const href = URL.createObjectURL(r.data);
  if (tab) {
    tab.location.href = href;
    setTimeout(() => URL.revokeObjectURL(href), 120000);
    return;
  }
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export const fmtDate = (s?: string | null) => (s ? new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "—");
export const fmtDateTime = (s?: string | null) => (s ? new Date(s).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
export const money = (n: number) => n.toLocaleString(undefined, { style: "currency", currency: "USD" });
